export default (context, stateProperty = 'form') => {
  return (e) => {
    const form   = context.state.data.get(stateProperty) || {};
    const target = e.target;

    if (target.getAttribute('type') === 'checkbox') {
      form[target.getAttribute('name')] = target.checked;
    } else {
      form[target.getAttribute('name')] = target.value;
    }

    context.setState({ data: context.state.data.set(stateProperty, form) });
  };
};



// WEBPACK FOOTER //
// ./app/lib/handleFormChange.js